<template>
  <div class="decision-glue">
    <div v-if="work">
      <div v-for="answer in work.answers" :key="answer.id">
        <glue-item :decision="answer" :check="check(answer)"></glue-item>
      </div>
    </div>
  </div>
</template>
<script>
import GlueItem from './GlueItem.vue';
export default {
  components: {
    GlueItem
  },
  name: "text",
  props: {
    work: {
      default: null,
    },
  },
  data() {
    return {

    };
  },
  methods: {
    check(answer) {
      for (let i = 0; i < this.work.decisions.length; i++) {
        if (this.work.decisions[i].answer_id == answer.id) {
          for (let j = 0; j < this.work.answers.length; j++) {
            if (this.work.decisions[i].answer == this.work.answers[j].id) {
              return this.work.answers[j];
            }
          }
        }
      }
      return null;
    }
  },
};
</script>


<style lang="scss">
.decision-glue {
  img {
    width: 100px;
    height: 100px;
    object-fit: contain;
    margin-right: 10px;
  }

  &-block {
    border: 1px solid #ebebeb;
    display: block;
    padding: 20px;
    border-radius: 10px;
    margin-bottom: 10px;
  }

  // &-item {

  // }
}
</style>

